module.exports = __webpack_public_path__ + "img/banner-1-mobile.d3cefc5e.webp";